import React                        from 'react';
import PropTypes                    from 'prop-types';
import Flux                         from '../../../flux/Flux';
import Translations                 from '../../../utils/Translations';
import DailybonusTodayOfferHeadLine from './DailybonusTodayOfferHeadLine';
import DailyBonusOfferBtn           from '../SubComponents/DailyBonusOfferBtn';
import OfferIcon                    from '../SubComponents/OfferIcon';
import {formatEffectAsPlainText}    from '../dailyBonusHelpers';

const {offerBgs} = Flux.Constants.DailyBonuses;

const DailybonusTodayMerchOffer = props => {
	const {offer, purchased, effect} = props;
	return (
		<div className='dailybonus-today-item'>
			<DailybonusTodayOfferHeadLine
				purchased={purchased}
				offer={offer}
			/>
			<div className="dailybonus-today-item__wrapper">
				<div className="dailybonus-today-item__left-side"
				     style={{backgroundImage: `url(${offerBgs.MERCHANDISE})`}}
				/>
				<div className="dailybonus-today-item__right-side">
					<div className="dailybonus-today-item__right-side__icon"><OfferIcon offer={offer} purchased={purchased} /></div>
					<div className="dailybonus-today-item__right-side__offer-effect">
						{formatEffectAsPlainText(effect)}
					</div>
					<div className="dailybonus-today-item__right-side__title">{Translations.get('OnAll365')}</div>
					<div className="dailybonus-today-item__right-side__description h-text-light">{Translations.get('InMerchShop365')}</div>
					<DailyBonusOfferBtn
						purchased={purchased}
						offer={offer}
						effect={effect}
					/>
				</div>
			</div>
		</div>
	);
};

DailybonusTodayMerchOffer.defaultProps = {
	effect:    {},
	purchased: false,
};

DailybonusTodayMerchOffer.propTypes = {
	offer:     PropTypes.string.isRequired,
	purchased: PropTypes.bool,
	effect:    PropTypes.object,
};

export default DailybonusTodayMerchOffer;